(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[587],{

/***/ 5419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useContactAction; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _services_nodeApiService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9885);
/* harmony import */ var _services_WindowService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2480);



const useContactAction = (gallery)=>{
    const recaptchaRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const [form, setForm] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        email: "",
        firstname: "",
        lastname: "",
        body: "",
        phone: ""
    });
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [errorMessage, setErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const [success, setSuccess] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [modal, setModal] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const onSubmit = (event)=>{
        event.preventDefault();
        setLoading(true);
        recaptchaRef.current.execute();
    };
    const onReCAPTCHAChange = async (captchaCode)=>{
        if (!captchaCode) {
            return;
        }
        setError(false);
        const service = gallery ? _services_nodeApiService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].contactGallery */ .Z.contactGallery(gallery.id, {
            ...form,
            captcha: captchaCode,
            channel: "discover",
            type: "contact_discover"
        }) : _services_nodeApiService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].contact */ .Z.contact({
            ...form,
            captcha: captchaCode
        });
        service.then((_response)=>{
            console.log(_response);
            formCallback();
        }, (res)=>{
            setError(true);
            setErrorMessage(res.response.data.errorMessage);
            _services_WindowService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].animatedScrollTop */ .Z.animatedScrollTop();
            setLoading(false);
        });
        recaptchaRef.current.reset();
    };
    const formCallback = ()=>{
        _services_WindowService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].animatedScrollTop */ .Z.animatedScrollTop();
        setSuccess(true);
        setLoading(false);
        setForm({
            email: "",
            firstname: "",
            lastname: "",
            body: "",
            phone: ""
        });
    };
    const handleClose = ()=>{
        setModal(false);
        setTimeout(()=>{
            setSuccess(false);
        }, 500);
    };
    const handleShow = ()=>{
        setSuccess(false);
        setModal(true);
    };
    return {
        error,
        errorMessage,
        form,
        setForm,
        modal,
        handleClose,
        handleShow,
        onSubmit,
        success,
        onReCAPTCHAChange,
        recaptchaRef,
        loading
    };
};


/***/ }),

/***/ 6882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useGetStartedAction; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const useGetStartedAction = ()=>{
    const [email, setEmail] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    const handleClick = ()=>{
        window.open("https://www.artplacer.com/signup?email=".concat(email));
    };
    return {
        email,
        setEmail,
        handleClick
    };
};


/***/ }),

/***/ 4064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4051);
/* harmony import */ var _Layout_ButtonCta__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8966);
/* harmony import */ var _Banner_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8927);
/* harmony import */ var _Banner_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Banner_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);







const Banner = (param)=>{
    let { children , image , height =500 , title , description , cta ="CTA" , onClick , contact =false  } = param;
    const defaultImage = "/images/banner-gallery.png";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Banner_module_css__WEBPACK_IMPORTED_MODULE_4___default().banner), "d-flex flex-column justify-content-center", "mb-4"),
        style: {
            backgroundImage: "url(".concat(image || defaultImage, ")"),
            height: "".concat(height, "px")
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container position-relative z-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        xs: 12,
                        sm: 12,
                        md: 8,
                        lg: 8,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("banner-text", contact ? (_Banner_module_css__WEBPACK_IMPORTED_MODULE_4___default().bannerTopPadding) : ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("fw-300 text-white fs-56px fs-mobile-40px lh-100", contact ? "mb-0" : "mb-4"),
                                    children: [
                                        title,
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-white font-primary fs-18px mb-4",
                                    children: [
                                        description,
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layout_ButtonCta__WEBPACK_IMPORTED_MODULE_2__/* .ButtonCta */ .N, {
                                    onClick: onClick,
                                    title: cta
                                })
                            ]
                        })
                    })
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Banner);


/***/ }),

/***/ 158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4425);
/* harmony import */ var _Button_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Button_module_css__WEBPACK_IMPORTED_MODULE_3__);




const Button = (param)=>{
    let { name , children , isAppleButton , isAndroidButton , type ="button" , onClick =()=>{} , size ="lg" , width , disabled =false , variant ="dark" , sx  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Button_module_css__WEBPACK_IMPORTED_MODULE_3___default()["button-container"]), "cursor-pointer", isAppleButton ? (_Button_module_css__WEBPACK_IMPORTED_MODULE_3___default().apple) : isAndroidButton ? (_Button_module_css__WEBPACK_IMPORTED_MODULE_3___default().android) : "", sx),
        style: {
            width: width ? width : "auto"
        },
        onClick: ()=>onClick(),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            disabled: disabled,
            type: type,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("btn-".concat(size, " btn-sm btn-block btn-").concat(variant, " fw-700 fs-12px ").concat((_Button_module_css__WEBPACK_IMPORTED_MODULE_3___default().button))),
            children: name || children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 8966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ButtonCta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _ButtonCta_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1772);
/* harmony import */ var _ButtonCta_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ButtonCta_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const ButtonCta = (param)=>/*#__PURE__*/ {
    let { className , onClick , title , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: onClick,
        type: "button",
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, "btn btn-outline-secondary fs-12px tt-u", (_ButtonCta_module_scss__WEBPACK_IMPORTED_MODULE_3___default().button)),
        children: title || children
    });
};


/***/ }),

/***/ 1286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const Container = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 6470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ HelmetTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const HelmetTitle = (param)=>/*#__PURE__*/ {
    let { title , hide =false  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: "".concat(title).concat(hide ? "" : " | Discover ArtPlacer")
        })
    });
};


/***/ }),

/***/ 7182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ SeoTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const SeoTags = (param)=>{
    let { description , title , image ="https://artplacer-nextjs.herokuapp.com/artplacer-logo.png" , url , canonical  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "ArtPlacer"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "ArtPlacer"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            })
        ]
    });
};


/***/ }),

/***/ 1350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _providers_AppProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2674);



const Wrapper = (param)=>{
    let { children  } = param;
    const { profile  } = (0,_providers_AppProvider__WEBPACK_IMPORTED_MODULE_2__/* .useAppContext */ .b)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "content-wrap".concat(profile.embedded ? " embedded" : ""),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Wrapper);


/***/ }),

/***/ 2587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4835);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4051);
/* harmony import */ var _services_utils_images__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3370);
/* harmony import */ var _actions_useContactAction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5419);
/* harmony import */ var _actions_useGetStartedAction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6882);
/* harmony import */ var _components_Layout_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(158);
/* harmony import */ var _components_Layout_ButtonCta__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8966);
/* harmony import */ var _components_Layout_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1286);
/* harmony import */ var _components_Layout_HelmetTitle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6470);
/* harmony import */ var _components_Layout_Wrapper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1350);
/* harmony import */ var _ContactPage_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(2090);
/* harmony import */ var _ContactPage_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_ContactPage_module_scss__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _components_Banner__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4064);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _components_Layout_SeoTags__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7182);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4853);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(253);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5477);



















const ContactPage = (param)=>{
    let { gallery  } = param;
    const { form , setForm , onSubmit , success , error , errorMessage , onReCAPTCHAChange , recaptchaRef , loading  } = (0,_actions_useContactAction__WEBPACK_IMPORTED_MODULE_3__/* .useContactAction */ .J)(gallery);
    const { email , setEmail , handleClick  } = (0,_actions_useGetStartedAction__WEBPACK_IMPORTED_MODULE_4__/* .useGetStartedAction */ .L)();
    const contactTitle = "Contact ".concat(gallery && gallery.name || "Us");
    const bannerDescription = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
        children: [
            "Visit\xa0",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "https://www.artplacer.com",
                target: "_blank",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                    children: "ArtPlacer"
                })
            }),
            " ",
            "to learn more or\xa0",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "https://www.artplacer.com/signup",
                target: "_blank",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                    children: "Join"
                })
            }),
            "\xa0to become a Partner Gallery."
        ]
    });
    const buttonLabel = ()=>{
        const label = gallery && "CONTACT GALLERY" || "SUBMIT";
        return loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            sx: {
                display: "flex",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                size: 18,
                color: "inherit"
            })
        }) : label;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_SeoTags__WEBPACK_IMPORTED_MODULE_12__/* .SeoTags */ .o, {
                title: "Contact Us | Discover ArtPlacer",
                description: "Get in touch and let us know how we can help.",
                url: "https://discover.artplacer.com/contact",
                canonical: "https://discover.artplacer.com/contact"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_HelmetTitle__WEBPACK_IMPORTED_MODULE_8__/* .HelmetTitle */ .i, {
                title: contactTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "contactBanner",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Banner__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    image: _services_utils_images__WEBPACK_IMPORTED_MODULE_2__/* .images.contact.header */ .W.contact.header,
                    height: 308,
                    title: contactTitle,
                    description: bannerDescription,
                    contact: true
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            xs: 12,
                            sm: 12,
                            md: {
                                span: 10,
                                offset: 1
                            },
                            lg: {
                                span: 10,
                                offset: 1
                            },
                            children: [
                                success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-100 alert alert-success",
                                        children: "Your message was sent successfully"
                                    })
                                }),
                                error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-100 alert alert-danger",
                                        children: errorMessage.map((error)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    error,
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                                ]
                                            }))
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    className: "align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            md: 6,
                                            xs: {
                                                order: "last"
                                            },
                                            sm: {
                                                order: "first"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_11___default()((_ContactPage_module_scss__WEBPACK_IMPORTED_MODULE_18___default().rightPostal), "d-flex flex-column justify-content-end"),
                                                style: {
                                                    backgroundImage: "url(".concat(_services_utils_images__WEBPACK_IMPORTED_MODULE_2__/* .images.contact.side */ .W.contact.side, ")")
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "container",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "text-lg-left z-1 position-relative ",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                                className: "color-white fs-34px",
                                                                children: [
                                                                    "Showcase your work. ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                    "Create your own Gallery Profile."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: (_ContactPage_module_scss__WEBPACK_IMPORTED_MODULE_18___default()["form-control"]),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_ButtonCta__WEBPACK_IMPORTED_MODULE_6__/* .ButtonCta */ .N, {
                                                                        className: "w-100",
                                                                        title: "Free 14-day Trial",
                                                                        onClick: handleClick
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            md: 6,
                                            xs: {
                                                order: "first"
                                            },
                                            sm: {
                                                order: "last"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                                                    className: "pt-4",
                                                    children: [
                                                        "Looking for product support? Visit our",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                            href: "http://help.artplacer.com/support/home",
                                                            target: "_blank",
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                                                    children: "Help Center"
                                                                })
                                                            ]
                                                        }),
                                                        " ",
                                                        "or let us know how we can help."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                    onSubmit: onSubmit,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Group */ .Z.Group, {
                                                            controlId: "exampleForm.ControlInput1",
                                                            className: "mb-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Label */ .Z.Label, {
                                                                    className: "text-capitalize fs-14px text-black",
                                                                    children: "Email"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Control */ .Z.Control, {
                                                                    className: (_ContactPage_module_scss__WEBPACK_IMPORTED_MODULE_18___default().inputFontSize),
                                                                    type: "email",
                                                                    onChange: (event)=>{
                                                                        setForm({
                                                                            ...form,
                                                                            email: event.target.value
                                                                        });
                                                                    },
                                                                    value: form.email,
                                                                    disabled: loading
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Group */ .Z.Group, {
                                                                    as: react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z,
                                                                    controlId: "firstName",
                                                                    className: "mb-2 pr-2 pl-3",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Label */ .Z.Label, {
                                                                            className: "text-capitalize text-black fs-14px",
                                                                            children: "First Name"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Control */ .Z.Control, {
                                                                            className: "input-font-size",
                                                                            type: "name",
                                                                            placeholder: "ie: Joe",
                                                                            onChange: (event)=>{
                                                                                setForm({
                                                                                    ...form,
                                                                                    firstname: event.target.value
                                                                                });
                                                                            },
                                                                            value: form.firstname,
                                                                            disabled: loading
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Group */ .Z.Group, {
                                                                    as: react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z,
                                                                    controlId: "lastName",
                                                                    className: "mb-2 pl-2 pr-3",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Label */ .Z.Label, {
                                                                            className: "text-capitalize text-black fs-14px",
                                                                            children: "Last Name"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Control */ .Z.Control, {
                                                                            className: "input-font-size",
                                                                            type: "name",
                                                                            placeholder: "ie: Doe",
                                                                            onChange: (event)=>{
                                                                                setForm({
                                                                                    ...form,
                                                                                    lastname: event.target.value
                                                                                });
                                                                            },
                                                                            value: form.lastname,
                                                                            disabled: loading
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Group */ .Z.Group, {
                                                            controlId: "exampleForm.ControlTextarea1",
                                                            className: "mb-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Label */ .Z.Label, {
                                                                    className: "text-capitalize fs-14px text-black",
                                                                    children: "Message"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Control */ .Z.Control, {
                                                                    className: (_ContactPage_module_scss__WEBPACK_IMPORTED_MODULE_18___default().inputFontSize),
                                                                    as: "textarea",
                                                                    rows: "3",
                                                                    onChange: (event)=>{
                                                                        setForm({
                                                                            ...form,
                                                                            body: event.target.value
                                                                        });
                                                                    },
                                                                    value: form.body,
                                                                    disabled: loading
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "font-primary color-gray-super-light fs-12px mt-1",
                                                                    children: "One of our curators or a member of our support team will be in touch as soon as possible."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Group */ .Z.Group, {
                                                            controlId: "exampleForm.ControlSelect2",
                                                            className: "mb-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Label */ .Z.Label, {
                                                                    className: "text-capitalize fs-14px text-black",
                                                                    children: "Phone Number"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Control */ .Z.Control, {
                                                                    className: (_ContactPage_module_scss__WEBPACK_IMPORTED_MODULE_18___default().inputFontSize),
                                                                    type: "number",
                                                                    onChange: (event)=>{
                                                                        setForm({
                                                                            ...form,
                                                                            phone: event.target.value
                                                                        });
                                                                    },
                                                                    value: form.phone,
                                                                    disabled: loading
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "font-primary color-gray-super-light fs-12px mt-1",
                                                                    children: "Please only include numbers: XXXXXXXXXX"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                            ref: recaptchaRef,
                                                            size: "invisible",
                                                            sitekey: "6LeDv1IaAAAAABVo8NAoSR50zN8nU1OgpZFBzyOO",
                                                            onChange: onReCAPTCHAChange
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                                            className: "mb-4"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            disabled: loading,
                                                            type: "submit",
                                                            children: buttonLabel()
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactPage);


/***/ }),

/***/ 9885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ services_nodeApiService; }
});

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./config/axiosNodeClient.js

const client = axios_default().create({
    baseURL: "https://discover.artplacer.com/api/"
});
client.interceptors.request.use((request)=>{
    console.log("Starting Request", "".concat(request.baseURL).concat(request.url));
    return request;
});
const axiosNodeClient = client;

;// CONCATENATED MODULE: ./services/nodeApiService.js

const nodeApiService = ()=>({
        artworks: (params)=>{
            return axiosNodeClient.get("artworks", {
                params
            });
        },
        galleryArtworks: (id, params)=>{
            return axiosNodeClient.get("galleries/".concat(id, "/artworks"), {
                params
            });
        },
        galleryArtworksByCollection: function(id, collection_slug) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return axiosNodeClient.get("galleries/".concat(id, "/collections/").concat(encodeURIComponent(collection_slug)), {
                params
            });
        },
        gallery: (id)=>axiosNodeClient.get("galleries/".concat(id)),
        galleries: (params)=>{
            return axiosNodeClient.get("galleries", {
                params
            });
        },
        search: (params)=>{
            return axiosNodeClient.get("search", {
                params
            });
        },
        spaces: (params)=>{
            return axiosNodeClient.get("spaces", {
                params
            });
        },
        contact: (body)=>{
            return axiosNodeClient.post("contact", body);
        },
        dataCapture: (galleryId, body)=>{
            return axiosNodeClient.post("galleries/".concat(galleryId, "/datacapture"), body);
        },
        contactGallery: (galleryId, body)=>{
            return axiosNodeClient.post("galleries/".concat(galleryId, "/contact"), body);
        },
        inquire: (artworkId, body)=>{
            return axiosNodeClient.post("artworks/".concat(artworkId, "/inquire"), body);
        },
        purchase: (artworkId, body)=>{
            return axiosNodeClient.post("artworks/".concat(artworkId, "/purchase"), body);
        },
        exhibitions: (params)=>{
            return axiosNodeClient.get("exhibitions", {
                params
            });
        }
    });
/* harmony default export */ var services_nodeApiService = (nodeApiService());


/***/ }),

/***/ 3370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ images; }
/* harmony export */ });
const images = {
    home: {
        header: "/images/Home-Banner.jpg",
        footer: "/images/Home-Banner-Footer.jpg"
    },
    contact: {
        header: "/images/ContactUs-Banner-New.jpg",
        side: "/images/Contact-Side-New.jpg"
    }
};


/***/ }),

/***/ 8927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__HlBcZ","container":"Banner_container__aD_nI","banner-text":"Banner_banner-text__tRy2N","white":"Banner_white__QZW0K","bannerTopPadding":"Banner_bannerTopPadding__mcq09"};

/***/ }),

/***/ 4425:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button-container":"Button_button-container__qEZ80","button":"Button_button__C97FB","android":"Button_android__22fHr","apple":"Button_apple__tbbth"};

/***/ }),

/***/ 1772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonCta_button__11mLL"};

/***/ }),

/***/ 2090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"rightPostal":"ContactPage_rightPostal__RHZn5","form-control-width-40":"ContactPage_form-control-width-40__0P7IW","inputFontSize":"ContactPage_inputFontSize__08nDa"};

/***/ })

}]);